// forEach polyfill for IE11
// @ts-ignore
if (typeof NodeList !== 'undefined' && window.NodeList && !NodeList.prototype.forEach) {
    // @ts-ignore
    NodeList.prototype.forEach = Array.prototype.forEach;
}
